<div
  #sliderContainer
  class="slider-container"
  [class.activated]="visualState === 'success' || visualState === 'loading'"
  [class.disabled]="disabled"
>
  <div class="slider-text">
    <ng-container [ngSwitch]="visualState">
      <span *ngSwitchCase="'idle'">{{ buttonTextKey | translate }}</span>
      <span *ngSwitchCase="'loading'" class="loading-dots"></span>
      <span *ngSwitchCase="'success'" class="loadingdone"></span>
    </ng-container>
  </div>

  <div #sliderButton class="slider">
    <img src="assets/gif/rightarrow1.gif" alt="right arrow icon" />
  </div>
</div>

<div class="pay-success" [class.activated]="visualState === 'success'">
  <img src="assets/gif/final_lottie.gif" alt="Success animation" />
</div>


